import { useMemo } from 'react'

import { Checkbox } from 'antd'

import { excludeNilFilter } from '@eastcoal/common/utils/lambda'

import { connect } from '@eastcoal/formily/exports/react'

import { FontStyleCheckboxGroupProps } from './interface'

const Component = ({ value = {}, onChange }: FontStyleCheckboxGroupProps) => {
  const options = useMemo(() => {
    return Object.keys(value)
      .map(key => {
        if (key === 'fontWeight') {
          return {
            key,
            label: '加粗',
            value: 'bold'
          }
        }
        if (key === 'textDecoration') {
          return {
            key,
            label: '下划线',
            value: 'underline'
          }
        }
      })
      .filter(excludeNilFilter)
  }, [value])

  const checkboxGroupValue = useMemo(() => Object.values(value), [value])

  const handleCheckboxGroupChange = (checkedValue: string[]) => {
    const newValue = options.reduce((acc, option) => {
      const { key, value } = option
      // 一定要保留原始 value 的 key，不然影响 options
      acc[key] = checkedValue.includes(value) ? value : ''
      return acc
    }, {})
    onChange?.(newValue)
  }

  return (
    <Checkbox.Group
      options={options}
      value={checkboxGroupValue}
      onChange={handleCheckboxGroupChange}
    />
  )
}

export const FontStyleCheckboxGroup = connect(Component)
